export const defaultToken = '';
export const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

export const GET_CERTIFICATE_START = 'GET_CERTIFICATE_START';
export const GET_CERTIFICATE_SUCCESS = 'GET_CERTIFICATE_SUCCESS';
export const GET_CERTIFICATE_FAIL = 'GET_CERTIFICATE_FAIL';
